<div>
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      <div class="course-status-wrapper">
        @if(isViewMode) {
          <div class="status-badge-container">
            @if(generalFormData.isDeployed) {
              <span class="status-indicator published">
                <span class="dot"></span>
                {{ 'COMMON.PUBLICATION-STATUS.PUBLISHED' | translate }}
              </span>
            } @else {
              <span class="status-indicator draft">
                <span class="dot"></span>
                {{ 'COMMON.PUBLICATION-STATUS.DRAFT' | translate }}
              </span>
            }
          </div>
        } @else {
          <dx-radio-group
            *ngIf="!isManager"
            [readOnly]="isViewMode"
            [items]="courseStatusOption"
            [value]="
              generalFormData.isDeployed
                ? courseStatusOption[1]
                : courseStatusOption[0]
            "
            (valueChange)="
              generalFormData.isDeployed = $event === courseStatusOption[1]
            "
            layout="horizontal"
          >
          </dx-radio-group>
        }

        <dx-button
          class="cta-btn"
          type="normal"
          [text]="(isCreateMode ? 'COMMON.CREATE' : 'COMMON.SAVE') | translate"
          (click)="submit()"
          *ngIf="!isViewMode && !isManager"
          [disabled]="isFileUploading"
        ></dx-button>
        <dx-button
          class="cta-btn"
          type="normal"
          [text]="'MANAGE-ELEARNING.DETAIL.VIEW-COURSE' | translate"
          (click)="navigateViewCourse()"
          *ngIf="isViewMode && isManager"
        ></dx-button>
        @if(isViewMode && !isManager) {
          @if(isClosed) {
            <dx-drop-down-button
              [splitButton]="true"
              [text]="'MANAGE-ELEARNING.DETAIL.VIEW-COURSE' | translate"
              stylingMode="contained"
              type="normal"
              [dropDownOptions]="{ width: 230 }"
              displayExpr="text"
              (onButtonClick)="navigateViewCourse()"
              (onItemClick)="handleDropdownAction($event)"
            >
              <dxi-item 
                id="show-feedback"
                [text]="'MANAGE-ELEARNING.DETAIL.SHOW-FEEDBACK' | translate" 
              ></dxi-item>
            </dx-drop-down-button>
          } @else {
            <dx-drop-down-button
              [splitButton]="true"
              [text]="'COMMON.EDIT' | translate"
              stylingMode="contained"
              type="normal"
              [dropDownOptions]="{ width: 230 }"
              displayExpr="text"
              (onButtonClick)="navigateToEdit()"
              (onItemClick)="handleDropdownAction($event)"
            >
              @if(generalFormData.isDeployed) {
                <dxi-item
                  id="add-attendees"
                  [text]="'MANAGE-ELEARNING.DETAIL.ADD-ATTENDEES' | translate"
                ></dxi-item>
              }

              <dxi-item
                id="show-feedback"
                [text]="'MANAGE-ELEARNING.DETAIL.SHOW-FEEDBACK' | translate"
              ></dxi-item>

              <dxi-item
                id="view-course"
                [text]="'MANAGE-ELEARNING.DETAIL.VIEW-COURSE' | translate"
              ></dxi-item>

              @if(!isComplianceTrainingTypeWithComplianceCategory) {
                <dxi-item
                  id="duplicate-course"
                  [text]="'MANAGE-ELEARNING.DETAIL.DUPLICATE-COURSE' | translate"
                ></dxi-item>
              }

              <dxi-item
                id="activity-log"
                [text]="'MANAGE-ELEARNING.DETAIL.ACTIVITY-LOG' | translate"
              ></dxi-item>

              @if(isComplianceTrainingTypeWithComplianceCategory) {
                <dxi-item
                  id="export-report"
                  [text]="'COMMON.EXPORT-FULL-REPORT-TO-EXCEL' | translate"
                ></dxi-item>
              }
            </dx-drop-down-button>
          }

        }
      </div>
    </div>
    <app-page-title
      [title]="
        'MANAGE-ELEARNING.DETAIL.' +
          (isCreateMode ? 'CREATE-TITLE' : 'EDIT-TITLE') | translate
      "
    >
    </app-page-title>
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-panel class="avatar-panel">
          <app-video-uploader
            *ngIf="!myCompetenceTrainingModel"
            [readOnly]="isViewMode"
            [isRemoveOptionHidden]="isRemoveOptionHidden"
            [isExternal]="
              !!currentCourse &&
              currentCourse.courseTemplate.courseContentType ==
                CourseContentTypeModel.External
            "
            [(hasCustomPreviewImage)]="hasCustomPreviewImage"
            #videoUploaderComponent
            (contentFileChange)="contentFileChange($event)"
            (isUploading)="uploadingFile($event)"
            [courseId]="id"
          ></app-video-uploader>
        </app-panel>
        <img
          *ngIf="myCompetenceTrainingModel"
          [hidden]="isEditMode"
          [src]="myCompetenceTrainingModel!.previewImage | safe:'url'"
          title="Image Preview"
          class="w-100 h-100"
        />
      </div>
      <div class="col-md-12 col-lg-7">
        <app-panel class="no-top-margin">
          <dx-form
            #generalForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="generalFormData"
            [readOnly]="isViewMode"
          >
            <dxi-item dataField="name">
              <dxo-label [text]="'COMMON.FIELDS.TITLE' | translate"></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="
                  'MANAGE-ELEARNING.DETAIL.NAME-IS-REQUIRED' | translate
                "
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item
              dataField="description"
              editorType="dxTextArea"
              [editorOptions]="{ height: '115px' }"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
              ></dxo-label>
            </dxi-item>
          </dx-form>
        </app-panel>
      </div>
    </div>
    <app-panel>
      <dx-tabs
        width="100%"
        [selectedIndex]="selectedDescriptionTab"
        [showNavButtons]="false"
        [dataSource]="descriptionTabs"
        (onItemClick)="onDescriptionTabChange($event)"
      ></dx-tabs>
      <div
        *ngIf="selectedDescriptionTab == 0"
        class="course-description-wrapper"
      >
        <app-expandable-text-editor
          [readOnly]="isViewMode"
          [(value)]="generalFormData.descriptionExtended"
          [(isExpanded)]="isDescriptionExpanded"
        ></app-expandable-text-editor>
        <div 
          *ngIf="userContext.canUseTextTemplates"
          class="text-template-container"
        >
          <app-text-template-selector
            *ngIf="!isViewMode"
            [type]="descriptionTextTemplateType"
            [content]="generalFormData.descriptionExtended"
            (contentChange)="onTemplateContentChanged($event)"
          ></app-text-template-selector>
        </div>
      </div>
      <div
        *ngIf="selectedDescriptionTab == 1"
        class="course-description-wrapper"
      >
        <app-expandable-text-editor
          [readOnly]="isViewMode"
          [(value)]="generalFormData.descriptionCertificate"
          [(isExpanded)]="isCertificateDescriptionExpanded"
          [fontFamily]="certificateFontFamily"
          [fontSize]="certificateFontSize"
        >
          <div editor-extra-actions class="extra-actions">
            <dx-button
              [text]="'COMMON.CERTIFICATE-PREVIEW' | translate"
              class="preview-button"
              (click)="showCertificatePreview()"
            ></dx-button>
          </div>
        </app-expandable-text-editor>

        <dx-form
          class="legal-footer"
          labelMode="floating"
          [showColonAfterLabel]="false"
          [formData]="generalFormData"
          [readOnly]="isViewMode"
          *ngIf="generalFormData"
        >
          <dxi-item itemType="group" colCount="2">
            <dxi-item *ngIf="!isViewMode">
              <div *dxTemplate>
                <app-organisation-unit-footer-selector
                  [label]="'MANAGE-ELEARNING.DETAIL.CHOOSE-LEGAL-FOOTER-LOCATION' | translate"
                  [data]="certificateOrganizationUnits"
                  [(value)]="generalFormData.certificateFooterLocationId">
                </app-organisation-unit-footer-selector>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </div>
    </app-panel>
    <app-panel
      *ngIf="isViewMode && currentCourse && currentCourse.courseTemplate && personsByState"
      [title]="'ADMINISTRATION.PROCESSING-PROGRESS-TITLE' | translate"
    >
      <app-course-persons-table
        [courseTemplateId]="currentCourse.courseTemplate.id"
        [isDeployed]="currentCourse.courseTemplate.isDeployed"
        [trainingType]="currentCourse.courseTemplate.trainingType"
        [hasReminders]="!!currentCourse.courseTemplate.sendInfomailToEmployeesReminderDays"
        [complianceCategoryId]="currentCourse.courseTemplate.complianceCategoryId"
        [isClosed]="currentCourse.courseTemplate.isClosed"
        [renewalFrequency]="currentCourse.complianceCategory?.renewalFrequency"
        [personsByState]="personsByState"
      ></app-course-persons-table>
    </app-panel>
    <app-panel
      [title]="'MANAGE-ELEARNING.DETAIL.TRAINING-SETTINGS' | translate"
    >
      <dx-form
        labelMode="floating"
        [showColonAfterLabel]="false"
        [formData]="trainingSettingsFormData"
        [readOnly]="isViewMode"
        #trainingSettingsForm
        *ngIf="trainingSettingsFormData"
      >
        <dxi-item itemType="group">
          <dxo-col-count-by-screen
            [xs]="1"
            [sm]="1"
            [md]="1"
            [lg]="2"
          ></dxo-col-count-by-screen>
          <dxi-item
            itemType="group"
            [caption]="'TRAINING.FORM.GENERAL-SETTINGS' | translate"
          >
            <dxi-item dataField="link">
              <dxo-label
                [text]="'MANAGE-ELEARNING.DETAIL.LINK' | translate"
              ></dxo-label>
            </dxi-item>
            <dxi-item>
                <dxo-label
                  [text]="'COMMON.FIELDS.AUTHORS' | translate"
                ></dxo-label>
                <div *dxTemplate>
                  <dx-drop-down-box
                    [(value)]="trainingSettingsFormData.trainerIds"
                    valueExpr="id"
                    displayExpr="name"
                    [label]="'COMMON.FIELDS.AUTHORS' | translate"
                    [dataSource]="trainers"
                    [readOnly]="isViewMode"
                    labelMode="floating"
                    stylingMode="outlined"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="true"
                        [dataSource]="trainers"
                        dataStructure="plain"
                        keyExpr="id"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        displayExpr="name"
                        [selectByClick]="true"
                        (onItemSelectionChanged)="onAuthorSelected($event)"
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
            </dxi-item>
            <dxi-item
              *ngIf="trainingTypesOptions?.dataSource"
              dataField="trainingType"
              editorType="dxSelectBox"
              [editorOptions]="trainingTypesOptions"
            >
              <dxo-label
                [text]="'MANAGE-ELEARNING.DETAIL.TRAINING-TYPE' | translate"
              ></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'MANAGE-ELEARNING.DETAIL.TRAINING-TYPE-IS-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item
              *ngIf="
                trainingSettingsFormData.trainingType === TrainingType.IDD
              "
            >
              <dxo-label
                [text]="'MANAGE-ELEARNING.DETAIL.TRAINING-TIME' | translate"
              ></dxo-label>
              <div *dxTemplate>
                <div>
                  <dx-validator
                    [adapter]="trainingTimeAdapter"
                    validationGroup="trainingTimeGroup"
                  >
                    <dxi-validation-rule
                      type="custom"
                      [validationCallback]="validateTrainingTime"
                      [message]="'VALIDATIONS.TRAINING-TIME-MINUTE' | translate"
                    ></dxi-validation-rule>
                    <dx-validation-summary></dx-validation-summary>
                  </dx-validator>
                  <div #timePicker>
                    <app-time-picker
                      [isInvalid]="!isTrainingTimeValid"
                      [disabled]="isViewMode"
                      (timeChanged)="handleTimePicker($event)"
                      [defaultValue]="{
                        hours: trainingSettingsFormData.iddHours,
                        minutes: trainingSettingsFormData.iddMinutes
                      }"
                      [validationMessage]="'VALIDATIONS.TRAINING-TIME-MINUTE' | translate"
                    >
                    </app-time-picker>
                  </div>
                </div>
              </div>
            </dxi-item>
            <dxi-item
              *ngIf="
                trainingSettingsFormData.trainingType === TrainingType.Compliance
                && complianceCategoriesOptions
              "
              dataField="complianceCategoryId"
            >
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.COMPLIANCE-CATEGORY-REQUIRED' | translate"
              ></dxi-validation-rule>
              <div *dxTemplate>
                <dx-drop-down-box
                  #complianceCategoryDropDown
                  [readOnly]="isViewMode"
                  [(value)]="trainingSettingsFormData.complianceCategoryId"
                  [label]="('COMMON.FIELDS.COMPLIANCE-CATEGORY' | translate) + ' *'"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [dataSource]="complianceCategoriesOptions.dataSource || []"
                  labelMode="floating"
                  stylingMode="outlined"
                  [showClearButton]="true"
                  [(opened)]="isComplianceCategoryOpen"
                  (onValueChanged)="onComplianceCategoryValueChanged($event)"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="complianceCategoriesOptions.dataSource || []"
                      keyExpr="id"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      (onItemClick)="onComplianceCategorySelected($event)"
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
            @if(isComplianceTrainingTypeWithComplianceCategory) {
              <dxi-item *ngIf="renewalFrequency !== undefined">
                <div *dxTemplate>
                  <div #complianceDatePicker>
                    <app-compliance-course-date-selection
                      #complianceCourseDateSelection
                      [startDate]="trainingSettingsFormData.date?.start ?? null"
                      [endDate]="trainingSettingsFormData.date?.end ?? null"
                      [readOnly]="isViewMode"
                      [renewalFrequency]="renewalFrequency"
                    ></app-compliance-course-date-selection>
                  </div>
                </div>
              </dxi-item>
            }
            <dxi-item *ngIf="
              learningPathsOptions &&
              trainingSettingsFormData.learningPathIds.length
            ">              
              <dxo-label
                [text]="'MANAGE-ELEARNING.DETAIL.LEARNING-PATHS' | translate"
              ></dxo-label>
              <div *dxTemplate>
                <dx-drop-down-box
                  [value]="trainingSettingsFormData.learningPathIds"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [readOnly]="true"
                  [label]="'MANAGE-ELEARNING.DETAIL.LEARNING-PATHS' | translate"
                  [dataSource]="learningPathsOptions.dataSource || []"
                  labelMode="floating"
                  stylingMode="outlined"
                >
                </dx-drop-down-box>
              </div>
            </dxi-item>
            <dxi-item
              *ngIf="trainingSettingsFormData.trainingType !== TrainingType.Compliance"
            >
              <div *dxTemplate>
                <hr>
                <div class="publication-mode-container">
                  <app-publication-mode-selection
                    [mode]="trainingSettingsFormData.publishingMode"
                    (modeChange)="onPublishingModeChanged($event)"
                    [isCourse]="true"
                    [isViewMode]="isViewMode"
                  ></app-publication-mode-selection>
                </div>
              </div>
            </dxi-item>
            <dxi-item
              *ngIf="
                trainingSettingsFormData.publishingMode === 0 ||
                trainingSettingsFormData.publishingMode === 1
              "
              itemType="group"
            >
              <dxi-item
                dataField="sendInfomailToEmployeesReminderDays"
                editorType="dxNumberBox"
                [editorOptions]="{ 
                  readOnly: isViewMode || isComplianceTrainingTypeWithComplianceCategory
                }"
              >
                <dxo-label
                  [text]="
                    'MANAGE-ELEARNING.DETAIL.SEND-AUTOMATIC-REMINDER-IN-DAYS'
                      | translate
                  "
                ></dxo-label>
              </dxi-item>
            </dxi-item>
            <dxi-item
              *ngIf="
                trainingSettingsFormData.trainingType === 0 &&
                learningTypeOptions?.dataSource &&
                isWbdConfigured
              "
              [editorOptions]="learningTypeOptions"
              dataField="lernart"
              editorType="dxSelectBox"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.LEARNING-TYPE' | translate"
              ></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.LEARNING-TYPE-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item
              *ngIf="
                trainingSettingsFormData.trainingType === 0 &&
                learningContentOptions?.dataSource &&
                isWbdConfigured
              "
              [editorOptions]="learningContentOptions"
              dataField="lerninhalt"
              editorType="dxSelectBox"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.LEARNING-CONTENT' | translate"
              ></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.LEARNING-CONTENT-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group">
            <dxi-item>
              <div *dxTemplate>
                <app-event-publication-settings
                  [publishingMode]="trainingSettingsFormData.publishingMode"
                  [isCourse]="true"
                  [isViewMode]="isViewMode || isComplianceTrainingTypeWithComplianceCategory"
                  [personCount]="personCount"

                  [(visibilityMode)]="trainingSettingsFormData.visibilityMode"
                  [(selectedOrganizationUnitIds)]="trainingSettingsFormData.organisationUnitLocationIds"

                  [(trainingGroupIds)]="trainingSettingsFormData.trainingGroupIds"
                  [(trainingCategoryIds)]="trainingSettingsFormData.trainingCategoryIds"

                  [organizationUnits]="organizationUnits"
                  [trainingGroups]="trainingGroups"
                  [trainingCategories]="trainingCategories"
                ></app-event-publication-settings>
              </div>
            </dxi-item>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" colCount="2" cssClass="checkboxes-wrapper">
          <dxi-item
            editorType="dxCheckBox"
            dataField="sendCertificateLink"
            [editorOptions]="{
                text: 'COMMON.FIELDS.CERTIFICATE-LINK-IN-COMPLETION-MAIL' | translate,
              }"
          >
            <dxo-label [visible]="false"> </dxo-label>
          </dxi-item>
          <dxi-item
            editorType="dxCheckBox"
            dataField="sendFeedbackLink"
            [editorOptions]="{
              text: 'COMMON.FIELDS.FEEDBACK-LINK-IN-COMPLETION-MAIL' | translate,
            }"
          >
            <dxo-label [visible]="false"> </dxo-label>
          </dxi-item>
          @if(canDisplayAllowVideoFastForward) {
            <dxi-item
              editorType="dxCheckBox"
              dataField="allowVideoFastForward"
              [editorOptions]="{
                text: 'COMMON.FIELDS.ALLOW-VIDEO-FAST-FORWARD' | translate,
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
          }
        </dxi-item>
      </dx-form>
    </app-panel>
    <app-panel 
      [title]="'COMMON.UPLOAD-RELATED-DOCUMENTS' | translate" 
      *ngIf="isEditMode"
    >
      <div class="row">
        <div class="col-md-12 col-lg-5">
          <app-panel class="image-panel">
            <div id="document-upload" class="uploader-container">
              <div class="uploader-preview-container">
                <img src="assets/img/upload.jpg" />
                <span class="preview-title">{{
                  "COMMON.UPLOAD-DOCUMENT" | translate
                }}</span>
              </div>
            </div>
            <dx-file-uploader
              #fileUploader
              dialogTrigger="#document-upload"
              dropZone="#document-upload"
              [multiple]="false"
              uploadMode="useForm"
              [visible]="false"
              (valueChange)="onDocumentSelected($event)"
            ></dx-file-uploader>
          </app-panel>
        </div>
        <div class="col-md-12 col-lg-7">
          <app-panel class="course-files-panel">
            <div class="files-title">
              {{ "COMMON.FILES" | translate }} ({{
                currentCourse && currentCourse.files
                  ? currentCourse.files.length
                  : 0
              }})
            </div>
            <div
              class="full-height-list"
              *ngIf="currentCourse && currentCourse.files"
            >
              <div class="list-wrapper">
                <dx-list
                  [dataSource]="currentCourse.files"
                  class="striped-list"
                >
                  <div *dxTemplate="let item of 'item'">
                    <div class="file">
                      <div class="file-name">
                        <div>{{ item.fileName }}</div>
                        <div class="file-url">
                          {{ item.fileUrl }}
                        </div>
                      </div>
                      <div
                        class="close-action"
                        (click)="onRemoveFileClicked(item)"
                      >
                        <i class="dx-icon-close"></i>
                      </div>
                    </div>
                  </div>
                </dx-list>
              </div>
            </div>
          </app-panel>
        </div>
      </div>
    </app-panel>
    <app-panel *ngIf="isViewMode">
      <div class="files-title">
        {{ "COMMON.FILES" | translate }} ({{
          currentCourse && currentCourse.files
            ? currentCourse.files.length
            : 0
        }})
      </div>
      @if(currentCourse?.files?.length) {
        <div
          class="full-height-list"
          *ngIf="currentCourse && currentCourse.files"
        >
          <div class="list-wrapper">
            <dx-list
              [dataSource]="currentCourse.files"
              class="striped-list"
            >
              <div *dxTemplate="let item of 'item'">
                <div class="file">
                  <div class="file-name">
                    <div>{{ item.fileName }}</div>
                    <div class="file-url">
                      {{ item.fileUrl }}
                    </div>
                  </div>
                </div>
              </div>
            </dx-list>
          </div>
        </div>
      } @else {
        <div class="empty-state">
          {{ "MANAGE-ELEARNING.DETAIL.NO-FILES-UPLOADED" | translate }}
        </div>
      }
    </app-panel>
    <app-panel
      *ngIf="!isManager"
      [title]="'MANAGE-ELEARNING.DETAIL.LEARNING-CONTROL-QUESTIONS' | translate"
    >
      <div>
        {{
          "MANAGE-ELEARNING.DETAIL.ALL-QUESTIONS-HERE-ARE-MANDATORY-TO-BE-ANSWERED"
            | translate
        }}
      </div>
      <div class="row question-row">
        <div class="col">
          <dx-form
            #questionsForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="questionsFormData"
            [readOnly]="isViewMode"
            *ngIf="questionsFormData"
          >
            <dxi-item itemType="group" name="questions" colSpan="2">
              <dxi-item
                itemType="group"
                *ngFor="
                  let question of questionsFormData.questions;
                  let i = index
                "
              >
                <dxi-item itemType="group" colCount="3">
                  <dxi-item
                    [dataField]="'questions[' + i + '].question'"
                    colSpan="2"
                  >
                    <dxo-label
                      [text]="
                        'MANAGE-ELEARNING.DETAIL.TYPE-QUESTION-HERE' | translate
                      "
                    ></dxo-label>
                  </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" colCount="3">
                  <dxi-item
                    itemType="group"
                    [caption]="
                      'MANAGE-ELEARNING.DETAIL.ANSWER-OPTIONS' | translate
                    "
                    colSpan="2"
                  >
                    <dxi-item
                      *ngFor="let option of question.options; let j = index"
                      [dataField]="
                        'questions[' + i + '].options[' + j + '].option'
                      "
                      [editorOptions]="{
                        placeholder:
                          'MANAGE-ELEARNING.DETAIL.TYPE-ANSWER-HERE' | translate
                      }"
                      [cssClass]="'question-count-label'"
                    >
                      <dxo-label
                        location="left"
                        [text]="j + 1 + '.'"
                        req
                      ></dxo-label>
                    </dxi-item>
                    <dxi-item itemType="group" colCount="3">
                      <dxi-item>
                        <dxo-label [visible]="false"></dxo-label>
                        <div *dxTemplate>
                          <dx-button
                            [disabled]="isViewMode"
                            [text]="
                              'MANAGE-ELEARNING.DETAIL.ADD-OPTION' | translate
                            "
                            stylingMode="text"
                            type="default"
                            class="integration-btn"
                            (click)="addQuestionOption(i)"
                          >
                          </dx-button>
                        </div>
                      </dxi-item>
                      <dxi-item *ngIf="questionsFormData">
                        <dxo-label [visible]="false"></dxo-label>
                        <div *dxTemplate>
                          <dx-button *ngIf="questionsFormData.questions[i].options.length > minOptionsCount"
                            [disabled]="isViewMode"
                            [text]="
                              'MANAGE-ELEARNING.DETAIL.REMOVE-OPTION'
                                | translate
                            "
                            stylingMode="text"
                            type="danger"
                            (click)="removeQuestionOption(i)"
                          >
                          </dx-button>
                        </div>
                      </dxi-item>
                    </dxi-item>
                  </dxi-item>
                  <dxi-item
                    itemType="group"
                    [caption]="
                      'MANAGE-ELEARNING.DETAIL.INDICATE-THE-RIGHT-ANSWER'
                        | translate
                    "
                  >
                    <dxi-item>
                      <dxo-label [visible]="false"></dxo-label>
                      <div *dxTemplate>
                        <dx-radio-group
                          [readOnly]="isViewMode"
                          [dataSource]="question.options"
                          displayExpr="index"
                          valueExpr="index"
                          (valueChange)="selectCorrectAnswer(i, $event)"
                          class="question-radio"
                          [value]="question.answerIndex"
                        >
                        </dx-radio-group>
                      </div>
                    </dxi-item>
                  </dxi-item>
                </dxi-item>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </div>
      </div>
      <div class="questions-footer">
        <dx-button
          [text]="'MANAGE-ELEARNING.DETAIL.REMOVE-QUESTION' | translate"
          type="default"
          class="integration-btn"
          (click)="removeQuestion()"
          [disabled]="isViewMode || questionsFormData.questions.length < 2"
          *ngIf="questionsFormData"
        >
        </dx-button>
        <dx-button
          [text]="'MANAGE-ELEARNING.DETAIL.ADD-QUESTION' | translate"
          icon="add"
          class="integration-btn"
          [disabled]="isViewMode"
          (onClick)="addQuestion()"
        >
        </dx-button>
      </div>
    </app-panel>
  </app-page>
</div>

@if(showPreviewReportViewer) {
  <app-report-viewer-modal
    [title]="generalFormData.name"
    [(showModal)]="showPreviewReportViewer"
    [reportUrl]="reportUrl"
  ></app-report-viewer-modal>
}

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteFileModal"
  (submit)="onRemoveFileConfirm()"
  [options]="modalConfirmationOptions"
></app-confirmation-dialog>